import React, { useEffect, useState } from "react";
import styled from "styled-components";
import LoginForm from "./LoginForm";

const LoginPage = () => {
  return (
    <DivLogin>
      <LoginForm />
    </DivLogin>
  );
};

const DivLogin = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default LoginPage;
